import axios from 'axios';
/**
 * A simple store for storing the survey questions
 */
export const store = {
  state: {
    answers: {},
    lang: '',
    sessionId: null,
    status: '',
    survey: {},
    surveyId: ''
  },
  getQuestionAnswer (qSetId, qLinkId, qType, qLength) {
    return new Promise((resolve,reject) => {
      // if not matrix then check there is an answer
      if (qType !== 'matrix' && this.state.answers[qSetId] && this.state.answers[qSetId][qLinkId]) {
        resolve(this.state.answers[qSetId][qLinkId])
      }
    // if matrix check that there are the same amount of answers to questions
      else if (qType === 'matrix' && Object.keys(this.state.answers[qSetId][qLinkId]).length === qLength) {
        resolve(this.state.answers[qSetId][qLinkId])
      }
      else reject('No answer recorded')
    })
  },
  async getSurveyAction (sId, lang, queries = {}) {
    console.log(`retrieving survey data from API: ${process.env.VUE_APP_API_BASEURL}/survey/${sId}/${lang}`)
    const data = await axios.get(`${process.env.VUE_APP_API_BASEURL}/survey/${sId}/${lang}`)
    this.state.survey = data.data
    this.state.lang = lang
    this.state.surveyId = sId
    console.log('response!')
    if (this.state.survey.use === 'single' || this.state.survey.use === 'private') {
      console.log('survey use is single or private!')
      if (Object.keys(queries).length > 0 && queries.id) {
        const queryId = queries.id
        await axios.get(`https://dev-api.codeology.com.au/v1/patient/session?session=${queryId}`)
        .then(response=>{
          this.state.sessionId = queries.id
          return response.data
        }).catch(error=>{
          if (error.response.status === 404) {
            console.error('survey session not found');
            this.state.status = 'invalidLink'
          }
        })
      // if no id is provided  
      } else {
        console.error('session id not supplied');
        this.state.status = 'invalidLink'
      }
    }
    return this.state.survey
  },
  getSurveyStatus () {
    console.log(`getting survey status: ${this.state.status}`)
    return this.state.status.length > 0 ? this.state.status : null
  },
  setSurveyAnswer (qSetId, questionId, answer) {
    console.log('setting answer')
    // const [questionId] = answer
    if (!this.state.answers[qSetId]) {
      console.log(`initialising ${qSetId}`)
      this.state.answers[qSetId] = {[questionId]: answer}
    }
    else this.state.answers[qSetId][questionId] = answer
  },
  async submitSurvey () {
    console.log(`this.state.sessionId: ${this.state.sessionId}`)
    await axios({
      method: 'POST',
      url: `${process.env.VUE_APP_API_BASEURL}/survey/${this.state.surveyId}/${this.state.lang}`,
      params: {id: this.state.sessionId},
      headers: {'content-type': 'application/json'},
      data: {answer: this.state.answers}
    })
    .then(response => response)
    .catch(err => {
      console.error(err);
    });
    return this.state.answers
  }
}